const all = ['mail', 'webservice']
const mailAddresses = [...all, 'mailAddresses']
const maintainAuth = [...all, 'maintainAuth']

export const mailWebserviceKeys = {
  all,
  mailAddresses,
  maintainAuth,
}
